import { actionErrorNotifier } from 'core/utils/helpers'
import { actionCoreApi } from 'core/utils/api'
import { ActionType, dispatcherActionType } from 'core/utils/interfaces'
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper'
import { ApiTokensActions } from './ApiTokens.constants'
import { APiTokenRequestPayload } from './create-api-token/CreateApiToken.types'
import { IFilters, ISort } from 'core/actions/Actions.interfaces'
import { maxListParams } from 'core/utils/constants'
import ActionsList from 'core/actions/Actions.list'

export const fetchApiTokens = (params: ISort = maxListParams, filters?: IFilters): ActionType =>
  actionErrorNotifier(actionCoreApi(
    ApiTokensActions.FetchApiTokens,
    HTTPUrlHelper.getLimitedAccessTokenAPI(params, filters)
  ))

export const createApiToken = (payload: APiTokenRequestPayload): dispatcherActionType => actionErrorNotifier(
  actionCoreApi(
    ApiTokensActions.CreateApiToken,
    HTTPUrlHelper.getAccessTokenAPI(),
    'POST',
    payload
  )
)

export const editApiToken = (id: string, payload: APiTokenRequestPayload): dispatcherActionType => actionErrorNotifier(
  actionCoreApi(
    ApiTokensActions.EditApiToken,
    HTTPUrlHelper.updateApiTokenByIdAPI(id),
    'PUT',
    payload
  ), true,
  {
    title: '',
    message: 'notifications.apiTokens.editApiTokenSuccess'
  }
)

export const deleteApiToken = (ids: string[]): dispatcherActionType =>
  actionErrorNotifier(
    actionCoreApi(
      ApiTokensActions.DeleteApiToken,
      ids.map((id: string): string => `${HTTPUrlHelper.getAccessTokenAPI()}/${id}`),
      'DELETE'
    ), true,
    {
      title: '',
      message: 'notifications.apiTokens.deleteApiTokenSuccess'
    }
  )

  export const fetchApiById = (id: string): ActionType =>
  actionErrorNotifier(actionCoreApi(
    ActionsList.FetchApiToken,
    HTTPUrlHelper.getApiTokenByIdAPI(id)
  ))
